import React from "react";
import { Box } from "@mui/material";
import useSEO from "../../hooks/useSEO";

// Components
import Hero from "./components/Hero";
import TrustedBy from "./components/TrustedBy";
import SolutionsAccordion from "./components/SolutionsAccordion";
import IndustryGrid from "./components/IndustryGrid";
import DemoSection from "./components/DemoSection";
import ValueProp from "./components/ValueProp";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";

const NewHomePage = () => {
  // SEO Configuration
  useSEO({
    title: "Beanbag AI | Enterprise AI Solutions & Automation",
    description:
      "Transform your business with Beanbag AI. We provide end-to-end AI solutions including hyper-realistic voice agents, workflow automation, and predictive analytics.",
    keywords:
      "AI Solutions, Enterprise AI, Voice Agents, Workflow Automation, GenAI, Predictive Analytics",
    ogTitle: "Beanbag AI - Intelligent Enterprise Automation",
    ogDescription:
      "End-to-end AI services from workflow automation to hyper-realistic voice agents.",
    ogType: "website",
  });

  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh", color: "text.primary" }}>
      {/* 1. Hero Fold */}
      <Hero />

      {/* 2. Trusted By / Client Logos */}
      <TrustedBy />

      {/* 3. Selected AI Solutions (Deep Fold) */}
      <SolutionsAccordion />

      {/* 4. Industry Expertise (Broad Fold) */}
      <IndustryGrid />

      {/* 5. Interactive Voice Demo */}
      <DemoSection />

      {/* 6. Value Proposition */}
      <ValueProp />

      {/* 7. Testimonials */}
      <Testimonials />

      {/* 8. Pre-Footer CTA Section */}
      <CTASection />
    </Box>
  );
};

export default NewHomePage;

